import angular from 'angular';

import clipButton from './clipButton';
import CopyReportLink from './copyReportLink';
import dashboardByGroup from './dashboardByGroup';
import EventDetails from './eventDetails';
import GroupsButton from './GroupsButton';
import infoServices from './infoServices';

import Modals from './modals';
import OrgSelect from './orgSelect';

import MatchMapStylesConstant from './MatchMapStylesConstant';
import ResponsiveBreakpointsConfig from './configs/ResponsiveBreakpointsConfig';

import jsonTextarea from './json.directive';
import iframeOnLoad from './iframe.directive';
import ngRightClick from './ngRightClick.directive';
import ObserverService from './ObserverService';
import MapService from './MapService';
import SiteSelectComponent from './SiteSelectComponent';
import PrettyNamesConstant from './PrettyNamesConstant';
import StringToNumberDirective from './StringToNumberDirective';
import AutoFocusDirective from './AutoFocusDirective';

export default angular.module('petrocloud.base', [
  CopyReportLink,
  clipButton,
  dashboardByGroup,
  EventDetails,
  GroupsButton,
  infoServices,
  Modals,
  OrgSelect,
])
  .constant('MatchMapStyles', MatchMapStylesConstant)
  .constant('PrettyNamesConst', PrettyNamesConstant)
  .constant('ResponsiveBreakpoints', ResponsiveBreakpointsConfig)
  .service('MapService', MapService)
  .service('ObserverService', ObserverService)
  .directive('jsonTextarea', jsonTextarea)
  .directive('iframeOnload', iframeOnLoad)
  .directive('ngRightClick', ngRightClick)
  .directive('stringToNumber', StringToNumberDirective)
  .directive('autofocus', AutoFocusDirective)
  .component(SiteSelectComponent.name, SiteSelectComponent)
  .name;
